var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { DOWNLOAD_FINAL_CHARGES_REPORT_REQUEST, downloadFinalChargesReportFailure, downloadFinalChargesReportSuccess, } from "@/redux/actions";
import APIIN from "@/utils/APIIN";
const onFetchFinalChargesReportDownload = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const encodedBillingCycle = encodeURIComponent(action.payload.billingDate);
        try {
            APIIN.downloadLabel(`report/admin/charges/report?billingDate=${encodedBillingCycle}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchFinalChargesReportDownloadWorker(action) {
    try {
        const data = yield call(onFetchFinalChargesReportDownload, action);
        yield put(downloadFinalChargesReportSuccess(data));
    }
    catch (error) {
        yield put(downloadFinalChargesReportFailure(error));
    }
}
export function* watchFetchFinalChargesReportDownloadData() {
    yield takeLatest(DOWNLOAD_FINAL_CHARGES_REPORT_REQUEST, fetchFinalChargesReportDownloadWorker);
}
